import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { useTranslation } from 'next-i18next';

import { CHANNEL } from '@boss/constants/corporate-jobs';
import { IIVacancyContactPerson } from '@boss/types/corporate-jobs';
import { JobsPromotionBanner } from '@boss/ui';

type Props = {
  contactpersoon: IIVacancyContactPerson;
};
const JobDetailPromotionCta = ({ contactpersoon }: Props) => {
  const { t } = useTranslation(['jobs']);

  return (
    <JobsPromotionBanner
      buttonPosition="bottom"
      colorVariant={CHANNEL === 'jobs-b2c' ? 'beige' : 'green'}
      cta={{
        type: CHANNEL === 'jobs-b2c' ? 'link' : 'secondary',
        href: contactpersoon?.contactformulier,
        label: t('promotionCta.ctaText'),
        iconPosition: 'right',
        icon: CHANNEL === 'jobs-b2c' ? faArrowRight : null,
        labelClassName: CHANNEL === 'jobs-b2c' ? 'capitalize' : 'uppercase',
        className: CHANNEL === 'jobs-b2c' ? 'px-0' : '',
      }}
      /*image={{
        imageUrl: contactpersoon?.profielfoto?.uitgesneden ?? '/images/charlotte.png',
        imageAlt: '',
        id: 'Charlotte',
      }}*/
      imagePosition="right"
      variant={CHANNEL === 'jobs-b2c' ? 'b2c' : 'b2b'}
    >
      <h4>
        {t('promotionCta.heading')} {contactpersoon.voornaam}
      </h4>
      <p className="mb-3">
        {t('promotionCta.textLine1')}
        <br />
        {t('promotionCta.textLine2')}
      </p>
    </JobsPromotionBanner>
  );
};

export default JobDetailPromotionCta;
